var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Box, CardContent, CardHeader, FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Table, TableBody, TableCell, TableHead, TableRow, Typography, } from "@mui/material";
import { useEffect, useState } from "react";
import React from "react";
import { PlainTimePicker } from "../date-pickers";
import { EditForm } from "../forms";
import { Checkbox, TextField } from "../Input";
import { Duration, Now, PlainTime, tryParsePlainTime } from "../temporal";
export const Weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export function Accessibility({ enabled, loading, result, t, onSave }) {
    // const id = useParam("id");
    // const {t} = useLocalization();
    // const {loading, error, result} = useAsync(() => siteApi.getAccessibility(id), [id]);
    const [alwaysAccessible, setAlwaysAccessible] = useState(true);
    const [accessibleFrom, setAccessibleFrom] = useState(null);
    const [accessibleUntil, setAccessibleUntil] = useState(null);
    const [weekdayAccessibility, setWeekdayAccessibility] = useState(EMPTY_WEEKDAY_ACCESSIBLE_HOURS);
    const [accessDescription, setAccessDescription] = useState("");
    const [externalAccess, setExternalAccess] = useState("None");
    const [externalAccessForeignId, setExternalAccessForeignId] = useState("");
    useEffect(() => {
        var _a, _b, _c;
        if (result) {
            setAlwaysAccessible(result.alwaysAccessible);
            setAccessibleFrom((_a = tryParsePlainTime(result.accessibleFrom)) !== null && _a !== void 0 ? _a : null);
            setAccessibleUntil((_b = tryParsePlainTime(result.accessibleUntil)) !== null && _b !== void 0 ? _b : null);
            setWeekdayAccessibility(completeWeekdayAccessibleHours(result.weekdayAccessibleHours));
            setAccessDescription(result.accessDescription);
            setExternalAccess(result.externalAccess);
            setExternalAccessForeignId((_c = result.externalAccessForeignId) !== null && _c !== void 0 ? _c : "");
        }
    }, [result]);
    function handleSave() {
        return __awaiter(this, void 0, void 0, function* () {
            var objToSave = {
                alwaysAccessible,
                accessibleFrom: accessibleFrom === null || accessibleFrom === void 0 ? void 0 : accessibleFrom.toString(),
                accessibleUntil: accessibleUntil === null || accessibleUntil === void 0 ? void 0 : accessibleUntil.toString(),
                weekdayAccessibleHours: weekdayAccessibility,
                accessDescription,
                externalAccess,
                externalAccessForeignId,
            };
            yield onSave(objToSave);
            // await siteApi.updateAccessibility(id,objToSave)
        });
    }
    function handleWeekdayAccessibleFromChange(weekday, value) {
        setWeekdayAccessibility(prev => prev.map(timeframe => {
            return timeframe.weekday != weekday ? timeframe : Object.assign(Object.assign({}, timeframe), { accessibleFrom: value === null || value === void 0 ? void 0 : value.toString() });
        }));
    }
    function handleWeekdayAccessibleUntilChange(weekday, value) {
        setWeekdayAccessibility(prev => prev.map(timeframe => {
            return timeframe.weekday != weekday ? timeframe : Object.assign(Object.assign({}, timeframe), { accessibleUntil: value === null || value === void 0 ? void 0 : value.toString() });
        }));
    }
    if (!enabled) {
        return React.createElement(Typography, null, t("sites.settings.enableBookingRequired"));
    }
    return (React.createElement(Box, { maxWidth: "md" },
        React.createElement(EditForm, { loading: loading, onSave: handleSave, labels: t },
            React.createElement(CardHeader, { title: t("sites.accessibility.accessibleHours"), subheader: t("sites.accessibility.accessibleHoursIntro") }),
            React.createElement(CardContent, null,
                React.createElement(Checkbox, { label: t("sites.accessibility.alwaysAccessible"), checked: alwaysAccessible, onChange: setAlwaysAccessible })),
            React.createElement(CardHeader, { disableTypography: true, title: React.createElement(Typography, { variant: "subtitle1" }, t("sites.accessibility.generalAccessibleHours")), subheader: React.createElement(Typography, { variant: "body2" }, t("sites.accessibility.generalAccessibleHoursHelperText")) }),
            React.createElement(CardContent, null,
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4 },
                        React.createElement(PlainTimePicker, { label: t("sites.accessibility.accessibleFrom"), disabled: alwaysAccessible, value: accessibleFrom, onChange: setAccessibleFrom, fullWidth: true })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4 },
                        React.createElement(PlainTimePicker, { label: t("sites.accessibility.accessibleUntil"), disabled: alwaysAccessible, value: accessibleUntil, onChange: setAccessibleUntil, fullWidth: true })))),
            React.createElement(CardHeader, { disableTypography: true, title: React.createElement(Typography, { variant: "subtitle1" }, t("sites.accessibility.accessibleHoursByWeekday")), subheader: React.createElement(Typography, { variant: "body2" }, t("sites.accessibility.accessibleHoursByWeekdayHelperText")) }),
            React.createElement(CardContent, null,
                React.createElement(Table, { size: "small" },
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, null, t("sites.accessibility.weekday")),
                            React.createElement(TableCell, null, t("sites.accessibility.accessibleFrom")),
                            React.createElement(TableCell, null, t("sites.accessibility.accessibleUntil")))),
                    React.createElement(TableBody, null, weekdayAccessibility.map(({ weekday, accessibleFrom, accessibleUntil }) => {
                        var _a, _b;
                        return (React.createElement(TableRow, { key: weekday },
                            React.createElement(TableCell, null, t(`weekdays.${weekday}`)),
                            React.createElement(TableCell, null,
                                React.createElement(PlainTimePicker, { disabled: alwaysAccessible, size: "small", value: (_a = tryParsePlainTime(accessibleFrom)) !== null && _a !== void 0 ? _a : null, onChange: value => handleWeekdayAccessibleFromChange(weekday, value) })),
                            React.createElement(TableCell, null,
                                React.createElement(PlainTimePicker, { disabled: alwaysAccessible, size: "small", value: (_b = tryParsePlainTime(accessibleUntil)) !== null && _b !== void 0 ? _b : null, onChange: value => handleWeekdayAccessibleUntilChange(weekday, value) }))));
                    })))),
            React.createElement(CardHeader, { title: t("sites.accessibility.accessDescription"), subheader: t("sites.accessibility.accessDescriptionHelperText") }),
            React.createElement(CardContent, null,
                React.createElement(TextField, { label: t("sites.accessibility.accessDescription"), value: accessDescription, multiline: true, rows: 3, fullWidth: true, onChange: setAccessDescription })),
            React.createElement(CardHeader, { title: t("sites.accessibility.externalAccess"), subheader: t("sites.accessibility.externalAccessIntro") }),
            React.createElement(CardContent, null,
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true },
                        React.createElement(FormControl, null,
                            React.createElement(FormLabel, null, t("sites.accessibility.externalAccess")),
                            React.createElement(RadioGroup, { value: externalAccess, onChange: e => setExternalAccess(e.currentTarget.value), row: true },
                                React.createElement(FormControlLabel, { value: "None", control: React.createElement(Radio, null), label: "None" }),
                                React.createElement(FormControlLabel, { value: "Storebox", control: React.createElement(Radio, null), label: "Storebox" })))),
                    React.createElement(Grid, { item: true },
                        React.createElement(TextField, { label: t("sites.accessibility.externalAccessForeignId"), disabled: externalAccess == "None", value: externalAccessForeignId, onChange: setExternalAccessForeignId })))))));
}
function completeWeekdayAccessibleHours(value) {
    return EMPTY_WEEKDAY_ACCESSIBLE_HOURS.map(({ weekday }) => {
        const weekdayValue = value.find(v => v.weekday == weekday);
        return ({
            weekday,
            accessibleFrom: weekdayValue === null || weekdayValue === void 0 ? void 0 : weekdayValue.accessibleFrom,
            accessibleUntil: weekdayValue === null || weekdayValue === void 0 ? void 0 : weekdayValue.accessibleUntil,
        });
    });
}
const EMPTY_WEEKDAY_ACCESSIBLE_HOURS = [
    { weekday: "Monday", accessibleFrom: undefined, accessibleUntil: undefined },
    { weekday: "Tuesday", accessibleFrom: undefined, accessibleUntil: undefined },
    { weekday: "Wednesday", accessibleFrom: undefined, accessibleUntil: undefined },
    { weekday: "Thursday", accessibleFrom: undefined, accessibleUntil: undefined },
    { weekday: "Friday", accessibleFrom: undefined, accessibleUntil: undefined },
    { weekday: "Saturday", accessibleFrom: undefined, accessibleUntil: undefined },
    { weekday: "Sunday", accessibleFrom: undefined, accessibleUntil: undefined },
];
/**
 * Accessibility common functions
 */
export function dayOfWeekAsString(dayIndex) {
    return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][dayIndex] || "";
}
export const getStartOfAccessibleToday = (accessibility) => {
    if (accessibility) {
        if (accessibility.alwaysAccessible) {
            return "00:00";
        }
        const dayOfWeek = (new Date()).getDay();
        if (accessibility.weekdayAccessibleHours) {
            const dowTimes = accessibility.weekdayAccessibleHours.find(dow => dow.weekday === dayOfWeekAsString(dayOfWeek));
            return dowTimes && dowTimes.accessibleFrom ? dowTimes.accessibleFrom : accessibility.accessibleFrom;
        }
    }
};
export const getStartOfAccessible = (accessibility, day) => {
    if (accessibility) {
        if (accessibility.alwaysAccessible) {
            return "00:00";
        }
        const dayOfWeek = day.getDay();
        if (accessibility.weekdayAccessibleHours) {
            const dowTimes = accessibility.weekdayAccessibleHours.find(dow => dow.weekday === dayOfWeekAsString(dayOfWeek));
            return dowTimes && dowTimes.accessibleFrom ? dowTimes.accessibleFrom : accessibility.accessibleFrom;
        }
    }
};
export const getEndOfAccessibleToday = (accessibility) => {
    if (accessibility) {
        if (accessibility.alwaysAccessible) {
            return "24:00";
        }
        const dayOfWeek = (new Date()).getDay();
        if (accessibility.weekdayAccessibleHours) {
            const dowTimes = accessibility.weekdayAccessibleHours.find(dow => dow.weekday === dayOfWeekAsString(dayOfWeek));
            return dowTimes && dowTimes.accessibleUntil ? dowTimes.accessibleUntil : accessibility.accessibleUntil;
        }
    }
};
export const getEndOfAccessible = (accessibility, day) => {
    if (accessibility) {
        if (accessibility.alwaysAccessible) {
            return "24:00";
        }
        const dayOfWeek = day.getDay();
        if (accessibility.weekdayAccessibleHours) {
            const dowTimes = accessibility.weekdayAccessibleHours.find(dow => dow.weekday === dayOfWeekAsString(dayOfWeek));
            return dowTimes && dowTimes.accessibleUntil ? dowTimes.accessibleUntil : accessibility.accessibleUntil;
        }
    }
};
// returns the until time for the booking, depending on if the cube has accessibility defined or not
export const getUntil = (from, accessibility, duration) => {
    if (accessibility && accessibility.accessibleUntil) {
        const endOfDay = getEndOfAccessibleToday(accessibility);
        const now = Now.instant().toZonedDateTimeISO("Europe/Vienna");
        const until = now.with({
            hour: endOfDay === null || endOfDay === void 0 ? void 0 : endOfDay.split(":")[0],
            minute: endOfDay === null || endOfDay === void 0 ? void 0 : endOfDay.split(":")[1],
            second: 0,
            millisecond: 0,
            microsecond: 0,
        });
        return until;
    }
    return from.add(Duration.from({ minutes: duration }));
};
/**
 * @param timeOnly example "14:00"
 * @returns
 */
export function toZonedDateTime(timeOnly) {
    const now = Now.instant().toZonedDateTimeISO("Europe/Vienna");
    const until = now.with({
        hour: timeOnly === null || timeOnly === void 0 ? void 0 : timeOnly.split(":")[0],
        minute: timeOnly === null || timeOnly === void 0 ? void 0 : timeOnly.split(":")[1],
        second: 0,
        millisecond: 0,
        microsecond: 0,
    });
    return until;
}
export function toZonedDateTimeGeneral(timeOnly, plainDateTime) {
    let zoned = plainDateTime.toZonedDateTime("Europe/Vienna");
    return zoned.with({
        hour: timeOnly === null || timeOnly === void 0 ? void 0 : timeOnly.split(":")[0],
        minute: timeOnly === null || timeOnly === void 0 ? void 0 : timeOnly.split(":")[1],
        second: 0,
        millisecond: 0,
        microsecond: 0,
    });
}
/**
 * Returns true if the "now" Parameter is in the accessible times.
 * @param accessibility
 * @param now
 * @returns
 */
export const isInAccesssibleTime = (accessibility, now = Now.instant().toZonedDateTimeISO("Europe/Vienna")) => {
    if (!accessibility || accessibility.alwaysAccessible) {
        return true;
    }
    const from = toZonedDateTime(getStartOfAccessibleToday(accessibility));
    const until = toZonedDateTime(getEndOfAccessibleToday(accessibility));
    // only compare opening times not date
    return ((PlainTime.compare(PlainTime.from(now), PlainTime.from(from)) == 1) && (PlainTime.compare(PlainTime.from(now), PlainTime.from(until)) == -1));
};
//# sourceMappingURL=accessibility.js.map